<div
    class="file-drag-drop"
    [class.drag-over]="isDragOver"
    (drop)="onFileDropped($event)"
    (dragover)="onDragOver($event)"
  >
    <img src="assets/media/svg/cloud-add.svg" alt="cloud" class="icon">
    <h5 class="title mb-0">Choose a file or drag & drop it here</h5>
    <p class="mb-0 sub-title" *ngIf="subtitle">{{ subtitle }}</p>
    <p class="mb-0 sub-title" *ngIf="!subtitle && allowedExtensions.length">{{ allowedLabel }} files supported</p>
    <div>
      <button
        type="button"
        class="btn"
        (click)="fileUpload.click()"
      >
        Browse file
      </button>
      <input
        type="file"
        #fileUpload
        hidden
        [accept]="acceptAttr"
        (change)="onFileSelected($event)"
      />
    </div>

    <p class="fw-bold mt-2" *ngIf="fileName">{{ fileName }}</p>
</div>